import { render, staticRenderFns } from "./ScreeningList.vue?vue&type=template&id=7a1cec60&scoped=true&"
import script from "./ScreeningList.vue?vue&type=script&lang=js&"
export * from "./ScreeningList.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningList.vue?vue&type=style&index=0&id=7a1cec60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1cec60",
  null
  
)

export default component.exports